export enum RepairChannel {
  CustomerSelfService = "CustomerSelfService",
  ERGO = "ERGO",
  Northgate = "Northgate",
  ColleagueSelfService = "ColleagueSelfService"
}